var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-tip",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 19l-4.671-4.323c-0.826-0.734-2.090-0.659-2.824 0.166s-0.659 2.090 0.166 2.824l6.215 5.695c0.844 0.751 2.142 0.653 2.865-0.214l10.249-12.147c0.707-0.849 0.592-2.11-0.256-2.817s-2.11-0.592-2.817 0.256l-8.927 10.561z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar-pentagon",
    viewBox: "0 0 38 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#526ed3",
    style: {
      fill: "var(--color1, #526ed3)"
    },
    d: "M1.778 8.889c0-3.927 3.184-7.111 7.111-7.111h18.032v28.444h-18.032c-3.927 0-7.111-3.184-7.111-7.111v-14.222z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6f6",
    style: {
      fill: "var(--color2, #f6f6f6)"
    },
    d: "M26.921 1.778h10.667v28.444h-10.667v-28.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526ed3",
    style: {
      fill: "var(--color1, #526ed3)"
    },
    d: "M26.921 1.778h1.433c1.334 0 2.555 0.746 3.164 1.933l4.255 8.294c1.143 2.228 1.177 4.863 0.092 7.119l-4.369 9.084c-0.592 1.231-1.838 2.014-3.204 2.014h-1.37v-28.444z"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.667 8c0-0.736 0.597-1.333 1.333-1.333h24c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-24c-0.736 0-1.333-0.597-1.333-1.333zM2.667 16c0-0.736 0.597-1.333 1.333-1.333h24c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-24c-0.736 0-1.333-0.597-1.333-1.333zM2.667 24c0-0.736 0.597-1.333 1.333-1.333h24c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-24c-0.736 0-1.333-0.597-1.333-1.333z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.521 5.069c0.16-0.155 0.384-0.249 0.621-0.249h5.718c0.24 0 0.463 0.094 0.619 0.247s0.237 0.353 0.237 0.553v0.38h-7.43v-0.38c0-0.199 0.080-0.398 0.235-0.551zM23.716 6h4.284c1.105 0 2 0.895 2 2s-0.895 2-2 2v17.2c0 1.284-0.52 2.509-1.435 3.407l-0.003 0.003c-0.912 0.892-2.143 1.39-3.418 1.39h-14.288c-1.278 0-2.509-0.498-3.421-1.393-0.453-0.443-0.813-0.972-1.059-1.555-0.247-0.585-0.375-1.214-0.376-1.849v-17.203c-1.105 0-2-0.895-2-2s0.895-2 2-2h4.286v-0.38c0-1.284 0.52-2.509 1.435-3.407l0.003-0.003c0.912-0.892 2.143-1.39 3.418-1.39h5.718c1.272 0 2.505 0.494 3.421 1.393s1.435 2.123 1.435 3.407v0.38zM24 10h-16v17.198c0 0.103 0.021 0.204 0.061 0.298s0.098 0.181 0.172 0.252l0.004 0.004c0.156 0.153 0.377 0.248 0.619 0.248h14.288c0.236 0 0.461-0.094 0.62-0.249 0.156-0.154 0.236-0.352 0.236-0.551v-17.2z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 5.838c-0.22 0-0.43 0.087-0.586 0.243v0l-16.274 16.272-0.391 1.565 1.563-0.39 16.274-16.276c0.155-0.155 0.243-0.366 0.243-0.586s-0.087-0.43-0.243-0.586c-0.155-0.155-0.366-0.243-0.586-0.243zM20.586 3.252c0.905-0.905 2.134-1.414 3.414-1.414s2.509 0.509 3.414 1.414c0.906 0.905 1.414 2.134 1.414 3.414s-0.509 2.509-1.414 3.414c0 0-0 0-0 0l-16.666 16.668c-0.257 0.257-0.578 0.439-0.93 0.527l-5.334 1.33c-0.681 0.17-1.402-0.030-1.899-0.527s-0.696-1.218-0.526-1.899l1.334-5.334c0.088-0.352 0.27-0.673 0.526-0.929l16.666-16.664c0-0 0-0 0-0zM14 26c0-1.105 0.895-2 2-2h12c1.105 0 2 0.895 2 2s-0.895 2-2 2h-12c-1.105 0-2-0.895-2-2z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M14 14v-8c0-0.53 0.211-1.039 0.586-1.414s0.884-0.586 1.414-0.586c0.53 0 1.039 0.211 1.414 0.586s0.586 0.884 0.586 1.414v8h8c0.53 0 1.039 0.211 1.414 0.586s0.586 0.884 0.586 1.414c0 0.53-0.211 1.039-0.586 1.414s-0.884 0.586-1.414 0.586h-8v8c0 0.53-0.211 1.039-0.586 1.414s-0.884 0.586-1.414 0.586c-0.53 0-1.039-0.211-1.414-0.586s-0.586-0.884-0.586-1.414v-8h-8c-0.53 0-1.039-0.211-1.414-0.586s-0.586-0.884-0.586-1.414c0-0.53 0.211-1.039 0.586-1.414s0.884-0.586 1.414-0.586h8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-warning",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc700",
    style: {
      fill: "var(--color1, #ffc700)"
    },
    d: "M14.376 2.464c1.056-0.595 2.301-0.755 3.473-0.448s2.179 1.058 2.807 2.094l0.006 0.008 11.31 18.882c0.407 0.706 0.622 1.506 0.624 2.32s-0.209 1.616-0.613 2.323c-0.403 0.708-0.985 1.298-1.687 1.711s-1.5 0.636-2.315 0.645h-22.632c-0.815-0.009-1.613-0.232-2.315-0.645s-1.284-1.003-1.687-1.711c-0.403-0.708-0.615-1.509-0.613-2.323s0.217-1.615 0.624-2.32l0.016-0.028 11.294-18.852 1.716 1.028-1.71-1.036c0.416-0.686 1-1.254 1.7-1.646v-0.002zM16.098 6.18l-11.28 18.83c-0.055 0.101-0.084 0.214-0.083 0.329s0.032 0.227 0.089 0.327c0.057 0.099 0.139 0.183 0.238 0.241s0.211 0.091 0.326 0.093h22.556c0.115-0.003 0.227-0.035 0.325-0.094s0.18-0.142 0.237-0.241 0.087-0.212 0.089-0.327c0.001-0.115-0.027-0.228-0.083-0.328l-11.278-18.83c-0.060-0.097-0.143-0.178-0.243-0.233s-0.211-0.085-0.325-0.085c-0.114 0-0.226 0.029-0.326 0.085s-0.183 0.136-0.242 0.233zM16.666 10c0.53 0 1.039 0.211 1.414 0.586s0.586 0.884 0.586 1.414v5.334c0 0.53-0.211 1.039-0.586 1.414s-0.884 0.586-1.414 0.586c-0.531 0-1.039-0.211-1.414-0.586s-0.586-0.884-0.586-1.414v-5.334c0-0.53 0.211-1.039 0.586-1.414s0.884-0.586 1.414-0.586zM16.666 20.666c-0.531 0-1.039 0.211-1.414 0.586s-0.586 0.884-0.586 1.414c0 0.53 0.211 1.039 0.586 1.414s0.884 0.586 1.414 0.586h0.014c0.53 0 1.039-0.211 1.414-0.586s0.586-0.884 0.586-1.414c0-0.53-0.211-1.039-0.586-1.414s-0.884-0.586-1.414-0.586h-0.014z"
  })), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.414 6.586c-0.781-0.781-2.047-0.781-2.828 0s-0.781 2.047 0 2.828l6.586 6.586-6.586 6.586c-0.781 0.781-0.781 2.047 0 2.828s2.047 0.781 2.828 0l6.586-6.586 6.586 6.586c0.781 0.781 2.047 0.781 2.828 0s0.781-2.047 0-2.828l-6.586-6.586 6.586-6.586c0.781-0.781 0.781-2.047 0-2.828s-2.047-0.781-2.828 0l-6.586 6.586-6.586-6.586z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-alarm",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f45725",
    style: {
      fill: "var(--color5, #f45725)"
    },
    d: "M16.667 6.667c0.354 0 0.693 0.14 0.943 0.391s0.391 0.589 0.391 0.943v10.667c0 0.354-0.141 0.693-0.391 0.943s-0.589 0.391-0.943 0.391c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943v-10.667c0-0.354 0.141-0.693 0.391-0.943s0.589-0.391 0.943-0.391zM18 24c0 0.354-0.141 0.693-0.391 0.943s-0.589 0.391-0.943 0.391c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943c0-0.354 0.141-0.693 0.391-0.943s0.589-0.391 0.943-0.391c0.354 0 0.693 0.141 0.943 0.391s0.391 0.589 0.391 0.943z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-accept",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M0.727 16c0-8.837 7.163-16 16-16s16 7.163 16 16c0 8.837-7.163 16-16 16s-16-7.163-16-16zM16.727 2.909c-7.23 0-13.091 5.861-13.091 13.091s5.861 13.091 13.091 13.091c7.23 0 13.091-5.861 13.091-13.091s-5.861-13.091-13.091-13.091z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M22.791 11.283c0.597 0.537 0.646 1.457 0.108 2.054l-6.545 7.273c-0.259 0.288-0.622 0.46-1.008 0.48s-0.765-0.116-1.051-0.377l-3.636-3.306c-0.594-0.54-0.638-1.46-0.098-2.055s1.46-0.638 2.055-0.098l2.555 2.323 5.567-6.186c0.537-0.597 1.457-0.646 2.054-0.108z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-download",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#526ed3",
    style: {
      fill: "var(--color1, #526ed3)"
    },
    d: "M16 2c1.105 0 2 0.895 2 2v11.172l3.252-3.252c0.781-0.781 2.047-0.781 2.828 0s0.781 2.047 0 2.828l-6.666 6.666c-0.781 0.781-2.047 0.781-2.828 0l-6.666-6.666c-0.781-0.781-0.781-2.047 0-2.828s2.047-0.781 2.828 0l3.252 3.252v-11.172c0-1.105 0.895-2 2-2zM4 18c1.105 0 2 0.895 2 2v5.333c0 0.177 0.071 0.346 0.196 0.471s0.295 0.195 0.472 0.196h18.665c0.177-0 0.347-0.070 0.472-0.196s0.195-0.295 0.196-0.472v-5.333c0-1.105 0.895-2 2-2s2 0.895 2 2v5.334c-0.001 1.237-0.493 2.424-1.367 3.299s-2.060 1.366-3.297 1.367h-18.669c-1.237-0.001-2.424-0.493-3.299-1.367s-1.366-2.060-1.367-3.297v-5.335c0-1.105 0.895-2 2-2z"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.586 10.586c0.781-0.781 2.047-0.781 2.828 0l6.586 6.586 6.586-6.586c0.781-0.781 2.047-0.781 2.828 0s0.781 2.047 0 2.828l-8 8c-0.781 0.781-2.047 0.781-2.828 0l-8-8c-0.781-0.781-0.781-2.047 0-2.828z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-signOut",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.667 5.333c-0.354 0-0.693 0.14-0.943 0.391s-0.391 0.589-0.391 0.943v18.667c0 0.354 0.14 0.693 0.391 0.943s0.589 0.391 0.943 0.391h5.333c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-5.333c-1.061 0-2.078-0.421-2.828-1.172s-1.172-1.767-1.172-2.828v-18.667c0-1.061 0.421-2.078 1.172-2.828s1.768-1.172 2.828-1.172h5.333c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-5.333zM20.391 8.391c0.521-0.521 1.365-0.521 1.886 0l6.667 6.667c0.521 0.521 0.521 1.365 0 1.886l-6.667 6.667c-0.521 0.521-1.365 0.521-1.886 0s-0.521-1.365 0-1.886l4.391-4.391h-12.781c-0.736 0-1.333-0.597-1.333-1.333s0.597-1.333 1.333-1.333h12.781l-4.391-4.391c-0.521-0.521-0.521-1.365 0-1.886z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 37 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7043",
    style: {
      fill: "var(--color6, #ff7043)"
    },
    d: "M18.286 0.202l18.286 31.595h-36.571l18.286-31.595z"
  })), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-thumb-up",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M11.133 23.333h-3.8c-0.736 0-1.333-0.597-1.333-1.333v-6.667c0-0.736 0.597-1.333 1.333-1.333h3.8c0.11 0 0.2 0.090 0.2 0.2v8.933c0 0.11-0.090 0.2-0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M11.333 15.333l2.526-5.052c0.093-0.185 0.141-0.389 0.141-0.596v-2.352c0-0.736 0.597-1.333 1.333-1.333v0c1.473 0 2.667 1.194 2.667 2.667v5.333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M15.333 14h7.996c0.889 0 1.529 0.853 1.28 1.706l-2.33 8c-0.166 0.569-0.687 0.961-1.28 0.961h-5.114c-0.354 0-0.693-0.141-0.943-0.391l-0.552-0.552c-0.25-0.25-0.589-0.391-0.943-0.391h-2.114"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-thumb-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "f6f6f6",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M20.867 8.667h3.8c0.736 0 1.333 0.597 1.333 1.333v6.667c0 0.736-0.597 1.333-1.333 1.333h-3.8c-0.11 0-0.2-0.090-0.2-0.2v-8.933c0-0.11 0.090-0.2 0.2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "f6f6f6",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M20.667 16.667l-2.526 5.052c-0.093 0.185-0.141 0.389-0.141 0.596v2.352c0 0.736-0.597 1.333-1.333 1.333v0c-1.473 0-2.667-1.194-2.667-2.667v-5.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "f6f6f6",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M16.667 18h-7.996c-0.889 0-1.529-0.853-1.28-1.706l2.33-8c0.166-0.569 0.687-0.96 1.28-0.96h5.114c0.354 0 0.693 0.14 0.943 0.391l0.552 0.552c0.25 0.25 0.589 0.391 0.943 0.391h2.114"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.487c4c5c6bc78aa578bdb6a7c55f2603.svg";
export { ForwardRef as ReactComponent };